module.exports = __webpack_public_path__ + "img/BlinkArt_Bow_Medium.090d223b.png";